module.exports = __webpack_public_path__ + "img/MEDIA035.63785053.jpg";